<template>
    <slide-up-modal
        v-if="modalDisplayed"
        ref="emptyCustomerCommentsModal"
        modal-id="emptyCustomerCommentsModal"
        modal-title="Suppression des commentaires"
        @modal-closed="hideModal"
    >
        <p>
            Attention, le champs commentaires est vide / a été vidé de son contenu, voulez-vous continuer ?
        </p>

        <div style="margin-top: 20px;">
            <button @click="onAccepted" class="btn btn-primary btn-sm">Valider</button>
            <button @click="hideModal" class="btn btn-default btn-sm">Annuler</button>
        </div>
    </slide-up-modal>
</template>

<script>
    import SlideUpModal from 'components/Modals/SlideUpModal'

    export default {
        data() {
            return {
                modalDisplayed: false
            }
        },

        components: {
            SlideUpModal
        },

        methods: {
            displayModal() {
                this.modalDisplayed = true
            },

            hideModal() {
                this.modalDisplayed = false
            },

            onAccepted() {
                this.$emit('accepted')
                this.hideModal()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/EmptyCommentsModal.vue